import React, { Component } from 'react'
import { Spin } from 'antd'
import moment from 'moment'

class ListItems extends Component {
  getApplicationsData = job => {
    let applicationsList = []
    job.applications.forEach(item => {
      applicationsList.push(
        <div key={item.id}>
          {job.applications.length > 1 && <h6 className="marginTop20">{item.name}</h6>}
          <div className="row" key={item.id}>
            {item.requested_bec_date &&
              this.checkedDateListContains('Requested BEC') && (
                <div className="col-4">
                  <p className="jobDetailsHeader marginBottom0">Requested BEC</p>
                  <p>{moment(item.requested_bec_date).format('YYYY-MM-DD')}</p>
                </div>
              )}
            {item.received_bec_date &&
              this.checkedDateListContains('Received BEC') && (
                <div className="col-4">
                  <p className="jobDetailsHeader marginBottom0">Received BEC</p>
                  <p>{moment(item.received_bec_date).format('YYYY-MM-DD')}</p>
                </div>
              )}
            {item.bec_permit_expiration_date &&
              this.checkedDateListContains('BEC Permit Expiration') && (
                <div className="col-4">
                  <p className="jobDetailsHeader marginBottom0">BEC Permit Expiration</p>
                  <p>{moment(item.bec_permit_expiration_date).format('YYYY-MM-DD')}</p>
                </div>
              )}
            {item.requested_elevator_application_date &&
              this.checkedDateListContains('Requested Elevator Application') && (
                <div className="col-4">
                  <p className="jobDetailsHeader marginBottom0">Requested Elevator Application</p>
                  <p>{moment(item.requested_elevator_application_date).format('YYYY-MM-DD')}</p>
                </div>
              )}
            {item.received_elevator_application_date &&
              this.checkedDateListContains('Received Elevator Application') && (
                <div className="col-4">
                  <p className="jobDetailsHeader marginBottom0">Received Elevator Application</p>
                  <p>{moment(item.received_elevator_application_date).format('YYYY-MM-DD')}</p>
                </div>
              )}
            {item.elevator_application_expiration_date &&
              this.checkedDateListContains('Elevator Application Expiration') && (
                <div className="col-4">
                  <p className="jobDetailsHeader marginBottom0">Elevator Application Expiration</p>
                  <p>{moment(item.elevator_application_expiration_date).format('YYYY-MM-DD')}</p>
                </div>
              )}
            {item.requested_temporary_construction_use_amendment_date &&
              this.checkedDateListContains('Requested Temporary Construction Use Amendment') && (
                <div className="col-4">
                  <p className="jobDetailsHeader marginBottom0">
                    Requested Temporary Construction Use Amendment
                  </p>
                  <p>
                    {moment(item.requested_temporary_construction_use_amendment_date).format(
                      'YYYY-MM-DD'
                    )}
                  </p>
                </div>
              )}
            {item.received_temporary_construction_use_amendment_date &&
              this.checkedDateListContains('Received Temporary Construction Use Amendment') && (
                <div className="col-4">
                  <p className="jobDetailsHeader marginBottom0">
                    Received Temporary Construction Use Amendment
                  </p>
                  <p>
                    {moment(item.received_temporary_construction_use_amendment_date).format(
                      'YYYY-MM-DD'
                    )}
                  </p>
                </div>
              )}
            {item.temporary_construction_use_inspection_request_date &&
              this.checkedDateListContains('Temporary Construction Use Inspection Request') && (
                <div className="col-4">
                  <p className="jobDetailsHeader marginBottom0">
                    Temporary Construction Use Inspection Request
                  </p>
                  <p>
                    {moment(item.temporary_construction_use_inspection_request_date).format(
                      'YYYY-MM-DD'
                    )}
                  </p>
                </div>
              )}
            {item.temporary_construction_use_inspection_expiration_date &&
              this.checkedDateListContains('Temporary Construction Use Inspection Expiration') && (
                <div className="col-4">
                  <p className="jobDetailsHeader marginBottom0">
                    Temporary Construction Use Inspection Expiration
                  </p>
                  <p>
                    {moment(item.temporary_construction_use_inspection_expiration_date).format(
                      'YYYY-MM-DD'
                    )}
                  </p>
                </div>
              )}
            {item.final_inspection_request_date &&
              this.checkedDateListContains('Final Inspection Request') && (
                <div className="col-4">
                  <p className="jobDetailsHeader marginBottom0">Final Inspection Request</p>
                  <p>{moment(item.final_inspection_request_date).format('YYYY-MM-DD')}</p>
                </div>
              )}
            {item.bec_inspection_request_date &&
              this.checkedDateListContains('BEC Inspection Request') && (
                <div className="col-4">
                  <p className="jobDetailsHeader marginBottom0">BEC Inspection Request</p>
                  <p>{moment(item.bec_inspection_request_date).format('YYYY-MM-DD')}</p>
                </div>
              )}
          </div>
        </div>
      )
    })
    return applicationsList
  }

  checkedDateListContains = text => {
    const { checkedDateList } = this.props
    if (checkedDateList.length == 0) {
      return true
    }
    return checkedDateList.indexOf(text) >= 0
  }

  getJobList = () => {
    const { fullReport } = this.props
    let jobList = []

    fullReport.forEach(item => {
      if (item.applications && item.applications.length > 0) {
        jobList.push(
          <div>
            <h5 className="steps">{item.job_name}</h5>
            {this.getApplicationsData(item)}
          </div>
        )
      }
    })
    return jobList
  }

  render() {
    const { loadingFullReport, fullReport } = this.props
    return (
      <div>
        {loadingFullReport && <Spin />}
        {!loadingFullReport &&
          fullReport && (
            <div>
              <div style={{ marginTop: 20 }} className="row">
                <div className="col-12">
                  <h5>Applications/Permits Schedules</h5>
                  {this.getJobList()}
                </div>
              </div>
            </div>
          )}
      </div>
    )
  }
}

export default ListItems



// WEBPACK FOOTER //
// ./src/components/reports/maintenance_dob/application-schedules/ListItem.js